module.exports = __webpack_public_path__ + "static/img/carousel-2.e996f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/carousel-2.png
// module id = kyLo
// module chunks = 15